export const WEB = 'web';
export const MWEB = 'mweb';



// WEBPACK FOOTER //
// ./app/constants/platform.js